module.exports = __webpack_public_path__ + "img/四川天府新区合江幼儿园.c1c46045.jpg";